import React, { useRef, useState } from 'react'
import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { z } from 'zod'
import { Form, FormControl, FormField, FormItem, FormLabel } from '@/Components/ui/form'
import { Input } from '@/Components/ui/input'
import { Button } from '@/Components/ui/button'
import { useLoaderData, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import HeaderCard from '@/Components/HeaderCard'
import BodyCard from '@/Components/BodyCard'
import Loader from '@/Components/Common/Loader'
import HCHBPayorTypeService from '@/Service/HCHBPayorTypeServce'
import SearchableDropdown from '@/Components/Common/SearchableDropdown'
import WorkflowService from '@/Service/WorkflowService'
import NoDataFound from '@/Components/Common/NoDataFound'
import { Checkbox } from '@/Components/ui/checkbox'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/Components/ui/table'
const workflowTableSchema = z.array(
    z.object({
        state: z.string().min(1, { message: 'State required' }),
        action: z.string().min(1, { message: 'Action is required' }),
        next_state: z.string().min(1, { message: 'Next State is required' }),
        allowed: z.string().min(1, { message: 'Allowed is required' }),
    })
)
const CreateWorkflow = () => {
    const formRef = useRef(null)
    const [isSaving, setIsSaving] = useState(false)
    const [workflow_table, setWorkflowTable] = useState([])
    const [checkall, setcheckAll] = useState(false)
    const { stateData, roleData, actionData } = useLoaderData()
    const formSchema = z.object({
        workflow_name: z
            .string({
                message: 'Workflow is required',
            })
            .min(1, {
                message: 'Workflow is required',
            }),
    })

    const navigate = useNavigate()
    const form = useForm({
        shouldFocusError: false,
        resolver: zodResolver(formSchema),
        defaultValues: {
            workflow_name: '',
        },
    })

    async function onSubmit(values) {
        console.log(form.getValues('workflow_name'))

        try {
            workflowTableSchema.parse(workflow_table)
            setIsSaving(true)
            values['wms_workflow_table'] = workflow_table
            values['name'] = form.getValues('workflow_name')
            const resp = await WorkflowService.createWorkflow(values)
            if (resp.data.success) {
                console.log('resp', resp.data)
                setIsSaving(false)
                navigate(`/workflow/work-allocation/${resp.data.data.workflow_name}`)
            }
        } catch (err) {
            toast.error(err.errors[0]?.message || 'Validation failed')
            setIsSaving(false)
        }
    }

    function onError(errors, e) {
        const errorKeys = Object.keys(errors)
        if (errorKeys.length > 0 && errors[errorKeys[0]]?.message) {
            toast.error(errors[errorKeys[0]].message)
        } else {
            toast.error('Something went wrong.')
        }
    }

    const handleSaveClick = () => {
        if (formRef.current) {
            formRef.current.requestSubmit()
        }
    }

    const addWorkflow = () => {
        setWorkflowTable((prev) => {
            const newId = prev?.length > 0 ? prev[prev.length - 1].id + 1 : 1
            return [
                ...prev,
                {
                    id: newId,
                    checkbox: false,
                    state: '',
                    action: '',
                    next_state: '',
                    allowed: '',
                },
            ]
        })
    }

    const deleteoneWorkflow = (id) => {
        const updatedrows = workflow_table.filter((row) => !row.checkbox)
        let newdata = updatedrows.length > 0 ? updatedrows : []
        setWorkflowTable(() => newdata)
    }
    const deleteAllWorkflow = () => {
        setWorkflowTable([])
        setcheckAll(false)
    }

    const changeworkflowtableOne = (row, index) => {
        setWorkflowTable((prev) => {
            let updatedData = []

            prev.map((item, i) => {
                if (index == i) {
                    prev[i]['checkbox'] = !prev[i]['checkbox']
                }
                updatedData.push(item)
            })
            return updatedData
        })
    }

    const changeworktableAll = () => {
        let isChecked = !checkall
        setcheckAll((prev) => isChecked)

        setWorkflowTable((prev) => {
            let updatedData = []

            prev.map((item, i) => {
                prev[i]['checkbox'] = isChecked
                updatedData.push(item)
            })

            return updatedData
        })
    }
    return (
        <>
            <HeaderCard>
                <div className="flex justify-end items-center">
                    <div className="flex items-center justify-end gap-2">
                        <Button
                            className="bg-primary-purpal hover:bg-primary-purpal px-4"
                            onClick={handleSaveClick}
                            iconType="Save"
                            disabled={isSaving}
                        >
                            Save {isSaving && <Loader fullScreen={false} />}
                        </Button>
                    </div>
                </div>
            </HeaderCard>
            <BodyCard>
                <Form {...form}>
                    <form ref={formRef} onSubmit={form.handleSubmit(onSubmit, onError)} className="">
                        <div className="grid grid-cols-2 gap-y-3 gap-x-6">
                            <FormField
                                control={form.control}
                                name="workflow_name"
                                render={({ field }) => (
                                    <FormItem className="space-y-1">
                                        <FormLabel required={true}>Workflow Name</FormLabel>
                                        <FormControl>
                                            <Input
                                                className="shadow-none focus-visible:ring-transparent space-0 mt-0"
                                                placeholder="Workflow name"
                                                {...field}
                                            />
                                        </FormControl>
                                    </FormItem>
                                )}
                            />
                        </div>
                    </form>
                </Form>

                <div className="mt-5">
                    <h5 className="font-bold text-sm">Workflow Table</h5>
                    <Table className="mt-2">
                        <TableHeader>
                            <TableRow className="border">
                                <TableHead className="w-[5%] border">
                                    <Checkbox onClick={changeworktableAll} value={checkall} checked={checkall} />
                                </TableHead>
                                <TableHead className="w-[50px] border font-bold">Sr.No</TableHead>
                                <TableHead className="w-[300px] border font-bold">State</TableHead>
                                <TableHead className="w-[300px] border font-bold">Action</TableHead>
                                <TableHead className="w-[300px] border font-bold">Next State</TableHead>
                                <TableHead className="w-[300px] border font-bold">Allowed</TableHead>
                            </TableRow>
                        </TableHeader>
                        <TableBody>
                            {workflow_table?.length == 0 ? (
                                <TableRow className="border">
                                    <TableCell className="border" colSpan="6">
                                        <NoDataFound />
                                    </TableCell>
                                </TableRow>
                            ) : (
                                workflow_table?.map((row, index) => (
                                    <TableRow key={row.index} name="poc" className="border">
                                        <TableCell className="border">
                                            <Checkbox
                                                onClick={() => changeworkflowtableOne(row, index)}
                                                checked={row.checkbox}
                                                value={row.checkbox}
                                            />
                                        </TableCell>
                                        <TableCell className="border  px-0">{index + 1}</TableCell>
                                        <TableCell className="border  px-0">
                                            <SearchableDropdown
                                                selectedVal={row.state}
                                                options={stateData}
                                                label="state"
                                                handleChange={(val) => {
                                                    setWorkflowTable((prev) => {
                                                        let updatedData = []
                                                        prev.map((item, i) => {
                                                            if (i == index) {
                                                                prev[i]['state'] = val
                                                            }
                                                            updatedData.push(item)
                                                        })
                                                        return updatedData
                                                    })
                                                }}
                                                className="border-none w-full outline-none ring-0 focus-visible:ring-0 shadow-none"
                                                placeholder="State"
                                            />
                                        </TableCell>
                                        <TableCell className="border  px-0">
                                            <SearchableDropdown
                                                selectedVal={row.action}
                                                options={actionData}
                                                label="action"
                                                handleChange={(val) => {
                                                    setWorkflowTable((prev) => {
                                                        let updatedData = []
                                                        prev.map((item, i) => {
                                                            if (i == index) {
                                                                prev[i]['action'] = val
                                                            }
                                                            updatedData.push(item)
                                                        })
                                                        return updatedData
                                                    })
                                                }}
                                                className="border-none w-full outline-none ring-0 focus-visible:ring-0 shadow-none"
                                                placeholder="Action"
                                            />
                                        </TableCell>
                                        <TableCell className="border  px-0">
                                            <SearchableDropdown
                                                selectedVal={row.next_state}
                                                options={stateData}
                                                label="state"
                                                handleChange={(val) => {
                                                    setWorkflowTable((prev) => {
                                                        let updatedData = []
                                                        prev.map((item, i) => {
                                                            if (i == index) {
                                                                prev[i]['next_state'] = val
                                                            }
                                                            updatedData.push(item)
                                                        })
                                                        return updatedData
                                                    })
                                                }}
                                                className="border-none w-full outline-none ring-0 focus-visible:ring-0 shadow-none"
                                                placeholder="Next State"
                                            />
                                        </TableCell>
                                        <TableCell className="border px-0">
                                            <SearchableDropdown
                                                selectedVal={row.allowed}
                                                options={roleData}
                                                label="roles"
                                                handleChange={(val) => {
                                                    setWorkflowTable((prev) => {
                                                        let updatedData = []
                                                        prev.map((item, i) => {
                                                            if (i == index) {
                                                                prev[i]['allowed'] = val
                                                            }
                                                            updatedData.push(item)
                                                        })
                                                        return updatedData
                                                    })
                                                }}
                                                className="border-none w-full outline-none ring-0 focus-visible:ring-0 shadow-none"
                                                placeholder="Allowed"
                                            />
                                        </TableCell>
                                    </TableRow>
                                ))
                            )}
                        </TableBody>
                    </Table>

                    <div className="mt-2 flex gap-1">
                        <Button
                            type="button"
                            className=" hover:bg-gray-200 bg-gray-200 border-gray-800 text-black-600 text-[12px]"
                            onClick={addWorkflow}
                        >
                            Add Row
                        </Button>

                        {!checkall && workflow_table?.filter((row) => row.checkbox).length > 0 ? (
                            <Button type="button" className="bg-primary-red ml-1 font-normal" onClick={deleteoneWorkflow}>
                                Delete
                            </Button>
                        ) : null}

                        {checkall && workflow_table?.length > 0 && (
                            <Button type="button" className="bg-primary-red ml-1 font-normal" onClick={deleteAllWorkflow}>
                                Delete All
                            </Button>
                        )}
                    </div>
                </div>
            </BodyCard>
        </>
    )
}

export default CreateWorkflow
